<template>
  <el-dialog :title="title" :visible="dialogFormVisible" width="40%" :before-close="handleClose" :closeOnClickModal="false">
        <el-form label-width="120px" ref="model" :model="model" :rules="rules">
            <el-form-item label="配置项名称" prop="Name">
                <el-input size="small" v-model="model.Name" auto-complete="off" placeholder="请输入配置项名称" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="配置项英文key" prop="Key">
                <el-input size="small" v-model="model.Key" auto-complete="off" placeholder="请输入配置项英文key" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='handleClose'>取消</el-button>
        <el-button size="small" type="primary"  class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {AddSetting} from '../../api/setting'
export default {
    data() {
        return {
            title: '添加配置项',
            name: 'add',
            model: {
                Name: null, //配置项名称
                Key: '',   //配置项英文key
            },
            rules: {
                Name: [{ required: true, message: '请输入配置项名称', trigger: 'blur' }],
                Key: [{ required: true, message: '请输入配置项英文key', trigger: 'blur' }],
            },
        }
    },
    props: {
        dialogFormVisible: {
            required: true,
            type: Boolean
        }
    },  
    methods: {
        handleSave() {
            this.$refs.model.validate((valid) => {
                if (valid) {
                        this.AddSetting()
                } else {
                    this.$message({
                        message: '请填写完整信息',
                        type: 'error'
                    });
                }
            });
        },
        handleClose() {
            this.$emit('closeAddDialog')
        },
        AddSetting() {
            AddSetting(this.model).then(data=>{
                if(!data.iserror) {
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    this.handleClose();
                }
            })
        }
    }
}
</script>

<style>

</style>